import React from 'react';

import { ChallengeDetailsModal, RemoveIncentiveModal, ReplaceIncentiveModal } from '../../modals';

export const LoyaltyModalsProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      {children}
      <ReplaceIncentiveModal />
      <RemoveIncentiveModal />
      <ChallengeDetailsModal />
    </>
  );
};
